import React, { useCallback, useRef, useState } from 'react';
import { Table, Tooltip, Card, Statistic, Tag, Row, Col } from 'antd';
import FlexFileInput from '../../common/FlexFileInput';
import { readXlsxToJson } from '../../../utils/xlsx';
import { convertJsonData } from '../../../utils/data';
import { getColumnSearchProps } from '../../common/TableFilter';
import { useGlobalContext } from '../../../App';

/**
 * 導入整周行程數據（文件1）
 */
export default () => {
    const { scheduleData, setScheduleData } = useGlobalContext();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const [loading, setLoading] = useState(false);

    const columns = [
        {
            title: '服務日期', dataIndex: 'service_date', key: 'service_date', width: 120,
            ...getColumnSearchProps('service_date', '服務日期', searchInput, setSearchText, searchText, setSearchedColumn, searchedColumn),
        },
        {
            title: '服務時間', dataIndex: 'service_time', key: 'service_time', width: 120,
        },
        {
            title: '客戶編號', dataIndex: 'customer_ID', key: 'customer_ID', width: 120, ellipsis: { showTitle: false },
            ...getColumnSearchProps('customer_ID', '客戶編號', searchInput, setSearchText, searchText, setSearchedColumn, searchedColumn),
        },
        {
            title: '客戶名稱', dataIndex: 'name', key: 'name', width: 150, ellipsis: { showTitle: false },
            render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>,
        },
        { title: '集團公司編號', dataIndex: 'company_ID', key: 'company_ID', width: 120, },
        { title: '地址', dataIndex: 'address', key: 'address', width: 160, ellipsis: { showTitle: false },
            render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>,
        },
        {
            title: '服務種類', dataIndex: 'type', key: 'type', width: 100,
            render: (type) => {
                const color = type === 'PC' ? 'blue' : type === 'HY' ? 'green' : 'default';
                return <Tag color={color}>{type}</Tag>;
            },
            filters: [
                { text: 'PC', value: 'PC' },
                { text: 'HY', value: 'HY' },
                { text: 'FL', value: 'FL' },
                { text: 'BAF', value: 'BAF' },
            ],
            onFilter: (value, record) => record.type === value,
        },
        {
            title: '技術員', dataIndex: 'staff', key: 'staff', width: 150, ellipsis: { showTitle: false },
            ...getColumnSearchProps('staff', '技術員', searchInput, setSearchText, searchText, setSearchedColumn, searchedColumn),
        },
        { title: '黑名單工作人員', dataIndex: 'blacklist', key: 'blacklist', width: 160, ellipsis: { showTitle: false },
            render: (text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>,
        },
    ];

    const handleImport = useCallback((e) => {
        setLoading(true);
        const files = e.target.files;
        if (files) {
            const f = files[0];
            readXlsxToJson(f, (result) => {
                setLoading(false);
                const converted = convertJsonData(result, columns);
                setScheduleData(converted);
            }, { headerRow: 1 });
        }
    }, []);

    // 統計信息
    const pcCount = scheduleData?.filter(o => o.type === 'PC').length || 0;
    const hyCount = scheduleData?.filter(o => o.type === 'HY').length || 0;
    const techCount = new Set(scheduleData?.map(o => o.staff?.split(' ')[0]).filter(Boolean)).size || 0;

    return (
        <div>
            <Card size="small" style={{ marginBottom: 16 }}>
                <FlexFileInput text="導入整周行程數據（文件1）" accept=".xlsx,.xls" onChange={handleImport} />
            </Card>

            {scheduleData && scheduleData.length > 0 && (
                <Card size="small" style={{ marginBottom: 16 }}>
                    <Row gutter={16}>
                        <Col span={6}><Statistic title="總記錄數" value={scheduleData.length} /></Col>
                        <Col span={6}><Statistic title="PC單" value={pcCount} valueStyle={{ color: '#1890ff' }} /></Col>
                        <Col span={6}><Statistic title="HY單" value={hyCount} valueStyle={{ color: '#52c41a' }} /></Col>
                        <Col span={6}><Statistic title="技術員數" value={techCount} /></Col>
                    </Row>
                </Card>
            )}

            <div className="table-container">
                <Table
                    bordered
                    scroll={{ x: 'calc(800px + 50%)', y: 500 }}
                    loading={loading}
                    columns={columns}
                    dataSource={scheduleData || []}
                    size="small"
                />
            </div>
        </div>
    );
};
